import { ApplicationLoggerImpl as BaseLogger } from "@shared/services/application-logger.impl";

type ViteEnvValueType = string | boolean | undefined;

export class FrontendApplicationLogger extends BaseLogger {
  private static instance: FrontendApplicationLogger | undefined;

  private constructor() {
    super(import.meta.env.MODE === "production");
  }

  public static getInstance(): FrontendApplicationLogger {
    FrontendApplicationLogger.instance ??= new FrontendApplicationLogger();
    return FrontendApplicationLogger.instance;
  }

  protected override getLogLevelsFromEnvironment(): string | undefined {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Vite env values are typed as any
    const envValue: ViteEnvValueType = import.meta.env[
      "VITE_ALLOWED_LOG_LEVELS"
    ];
    if (typeof envValue === "string") {
      return envValue;
    }
    return undefined;
  }

  protected override addConsoleOutput(): void {
    if (!this.isProduction) {
      super.addConsoleOutput();
    }
  }

  protected override addAdditionalOutputs(): void {
    // Add analytics output for production when needed
  }

  // eslint-disable-next-line planta-v2/unknown-only-at-boundaries -- Logger legitimately handles unknown errors from logging operations
  protected handleLogError(message: string, error: unknown): void {
    if (!this.isProduction) {
      console.warn(message, error);
    }
  }
}
